<ion-grid>
  @if (!readOnly()) {
    <ion-row>
      <ion-col
        size="12"
        class="ion-text-wrap"
      >
        <ion-button
          size="small"
          [disabled]="isFormDisabled()"
          (click)="openContactBookModal()"
        >
          <ion-icon
            aria-hidden="true"
            slot="start"
            src="../assets/material-symbols/search_24dp.svg"
          ></ion-icon>
          Libreta de contactos
        </ion-button>

        @if (viewMode() === 'summary' && hasData()) {
          <ion-button
            size="small"
            fill="outline"
            [disabled]="isFormDisabled()"
            (click)="setManualMode.emit()"
          >
            <ion-icon
              aria-hidden="true"
              slot="start"
              src="../assets/material-symbols/edit_24dp.svg"
            ></ion-icon>
            Editar empresa
          </ion-button>
        }

        @if (viewMode() === 'summary') {
          <ion-button
            size="small"
            fill="outline"
            [disabled]="isFormDisabled()"
            (click)="createNewCompany()"
          >
            <ion-icon
              aria-hidden="true"
              slot="start"
              src="../assets/material-symbols/domain_24dp.svg"
            ></ion-icon>
            Nueva empresa
          </ion-button>
        } @else {
          <ion-button
            size="small"
            fill="outline"
            [disabled]="isFormDisabled()"
            (click)="createNewCompany()"
          >
            <ion-icon
              aria-hidden="true"
              slot="start"
              src="../assets/material-symbols/delete_24dp.svg"
            ></ion-icon>
            Borrar datos
          </ion-button>
        }
      </ion-col>
    </ion-row>
  }

  <ng-container [formGroup]="form()">
    @if (hasEssentialDataError()) {
      <ion-row>
        <ion-col size="12">
          <ion-label>
            <p><ion-text color="danger">Hay errores o faltan datos. Por favor, corríjalos para continuar</ion-text></p>
          </ion-label>
        </ion-col>
      </ion-row>
    }

    @if (currentViewMode() === 'summary') {
      <ion-row>
        <ion-col size="12">
          @let loc = locationSignal();
          @if (hasData()) {
            <ion-item
              lines="none"
              class="border-rounded"
              style="--background: var(--ion-color-light)"
            >
              <ion-label class="ion-text-wrap">
                <p>
                  <strong>{{ form().controls.companyName.value }}</strong> - NIF: {{ form().controls.taxId.value }}
                </p>
                <p>{{ form().controls.street.value }}</p>
                @if (loc) {
                  <p>
                    ({{ loc.postalCode }}) {{ loc.city }},
                    {{ 'states.' + loc.countryCode + loc.stateCode | translate }},
                    {{ 'countries.' + loc.countryCode | translate }}
                  </p>
                }
                @if (form().controls.contactFirstName.value || form().controls.contactLastName.value) {
                  <p>
                    Contacto: {{ form().controls.contactFirstName.value }} {{ form().controls.contactLastName.value }}
                  </p>
                }
                @if (form().controls.contactEmail.value) {
                  <p>Email: {{ form().controls.contactEmail.value }}</p>
                }
                @if (form().controls.contactPhone.value) {
                  <p>Teléfono: {{ form().controls.contactPhone.value }}</p>
                }
              </ion-label>
            </ion-item>
          } @else {
            <ion-item
              lines="none"
              class="border-rounded"
              style="--background: var(--ion-color-light)"
            >
              <ion-label class="ion-text-wrap">
                <p class="ion-color-medium">
                  No se ha seleccionado ninguna empresa. Busque en contactos o cree una nueva.
                </p>
              </ion-label>
            </ion-item>
          }
        </ion-col>
      </ion-row>
    }

    @if (currentViewMode() === 'manual') {
      <ion-row>
        <ion-col
          size-lg="8"
          size="12"
        >
          <ion-input
            formControlName="companyName"
            label="Nombre de la empresa"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="text"
            errorText="Obligatorio"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="4"
          size="12"
        >
          <ion-input
            formControlName="taxId"
            label="NIF"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="text"
            [errorText]="
              form().controls.taxId.hasError('blockedShipperTaxId')
                ? 'No se permite crear documentos con esta empresa como cargador'
                : 'Obligatorio'
            "
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="8"
          size="12"
        >
          <ion-input
            formControlName="street"
            label="Dirección (calle y número)"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="text"
            errorText="Obligatorio"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="4"
          size="12"
        >
          <ion-item
            lines="none"
            style="--background: var(--ion-color-light)"
          >
            @let location = locationSignal();

            @if (location && location.postalCode) {
              <ion-label class="ion-text-wrap">
                <p>
                  ({{ location.postalCode }}) {{ location.city }},
                  {{ 'states.' + location.countryCode + location.stateCode | translate }},
                  {{ 'countries.' + location.countryCode | translate }}
                </p>
              </ion-label>
              <ion-button
                slot="end"
                fill="outline"
                (click)="openPostalCodeModal()"
                [disabled]="isFormDisabled()"
              >
                <ion-icon
                  slot="icon-only"
                  src="../assets/material-symbols/edit_24dp.svg"
                ></ion-icon>
              </ion-button>
            } @else {
              <ion-label>
                <ion-button
                  size="small"
                  fill="outline"
                  color="secondary"
                  [disabled]="isFormDisabled()"
                  (click)="openPostalCodeModal()"
                >
                  <ion-icon
                    aria-hidden="true"
                    slot="start"
                    src="../assets/material-symbols/pin_drop_24dp.svg"
                  ></ion-icon>
                  Buscar ciudad / C.P.
                </ion-button>

                @if (form().touched && (companyRole() === 'shipper' || form().controls.contactEmail.value)) {
                  <p class="fs-sm">
                    <ion-text color="danger"> Error. Debe seleccionar un código postal / ciudad. </ion-text>
                  </p>
                }
              </ion-label>
            }
          </ion-item>
        </ion-col>

        <ion-col
          size-lg="3"
          size="12"
        >
          <ion-input
            formControlName="contactFirstName"
            label="Nombre"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="text"
            errorText="Introduce el nombre de la persona de contacto"
          ></ion-input>
        </ion-col>

        <ion-col
          size-lg="4"
          size="12"
        >
          <ion-input
            formControlName="contactLastName"
            label="Apellidos"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="text"
            errorText="Introduce los apellidos de la persona de contacto"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="5"
          size="12"
        >
          <ion-input
            formControlName="contactEmail"
            label="Email de Contacto"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            type="email"
            errorText="Email válido"
          ></ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-margin-bottom">
        <ion-col size="12"> </ion-col>
      </ion-row>
    }
  </ng-container>
</ion-grid>
